<template>
  <svg
    :height="height"
    :width="width"
    :fill="fill"
    x="0px"
    y="0px"
    viewBox="0 0 500 500"
    xml:space="preserve"
  >
    <path
      d="M136.31,87c1.08-16.55,6.86-24,18.21-23.99c11.33,0.01,16.99,7.31,18.18,23.72c19.77,0,39.56,0,59.82,0
			c0-2.07-0.06-4.15,0.01-6.23c0.33-9.77,8.26-17.48,17.95-17.49c9.7-0.01,17.64,7.67,17.99,17.44c0.07,1.99,0.01,3.99,0.01,6.26
			c19.96,0,39.75,0,60.04,0c0-2.02-0.06-4.1,0.01-6.18c0.32-9.77,8.23-17.5,17.91-17.53c9.7-0.03,17.66,7.64,18.03,17.41
			c0.08,1.99,0.01,3.99,0.01,6.59c1.45,0,2.76,0,4.07,0c10.37,0,20.75-0.04,31.12,0.01c17.8,0.09,30.8,12.98,30.81,30.78
			c0.04,91.5,0.05,182.99,0,274.49c-0.01,17.75-13.07,30.69-30.9,30.69c-99.37,0.03-198.74,0.03-298.11,0
			c-18-0.01-30.94-13-30.95-31.03c-0.03-91.25-0.03-182.49,0-273.74c0-18.29,12.88-31.14,31.14-31.2
			C113.13,86.97,124.6,87,136.31,87z M82.5,171.18c0,1.54,0,2.89,0,4.23c0,71.73,0,143.46,0,215.18c0,13.27,7.1,20.41,20.31,20.41
			c98.47,0,196.94,0,295.41,0c13.21,0,20.28-7.13,20.28-20.45c0-71.73,0-143.46,0-215.18c0-1.34,0-2.68,0-4.19
			C306.46,171.18,194.78,171.18,82.5,171.18z M82.58,158.73c112.21,0,223.97,0,335.92,0c0-13.88,0.05-27.49-0.02-41.09
			c-0.05-10.98-7.7-18.57-18.69-18.63c-10.75-0.06-21.49-0.02-32.24,0c-0.95,0-1.9,0.16-3.06,0.26c0,5.59,0.02,10.94,0,16.3
			c-0.04,11.25-7.55,19.38-17.92,19.42c-10.38,0.04-18.03-8.1-18.07-19.26c-0.02-5.46,0-10.92,0-16.5c-20.17,0-39.95,0-60.02,0
			c0,6.2,0.11,12.18-0.03,18.15c-0.21,9.22-7.3,16.74-16.32,17.55c-8.95,0.8-17.11-5.03-19.07-13.96c-0.61-2.76-0.49-5.7-0.54-8.56
			c-0.08-4.43-0.02-8.87-0.02-13.21c-20.3,0-40,0-60.02,0c0,6.17,0.11,12.15-0.02,18.11c-0.23,9.98-8.28,17.75-18.13,17.67
			c-9.67-0.08-17.57-7.84-17.79-17.64c-0.13-6.06-0.02-12.13-0.02-18.31c-12.81,0-25.05-0.22-37.28,0.08
			c-8.62,0.21-16.28,7.39-16.54,16C82.26,129.57,82.58,144.06,82.58,158.73z M148.5,99.07c0,5.61-0.04,11.21,0.01,16.82
			c0.04,4.39,2.35,7.07,5.96,7.09c3.62,0.02,6-2.68,6.01-7.04c0.04-11.34,0.05-22.67,0-34.01c-0.02-4.3-2.52-7-6.15-6.9
			c-3.51,0.1-5.77,2.69-5.82,6.85C148.45,87.61,148.5,93.34,148.5,99.07z M244.5,98.62c0,5.86-0.05,11.71,0.02,17.57
			c0.05,4.12,2.38,6.73,5.88,6.79c3.51,0.06,6.05-2.56,6.08-6.59c0.07-11.59,0.07-23.17,0-34.76c-0.02-4.05-2.55-6.65-6.07-6.6
			c-3.53,0.06-5.84,2.63-5.89,6.78C244.45,87.41,244.5,93.01,244.5,98.62z M352.5,99c0-5.61,0.03-11.21-0.01-16.82
			c-0.03-4.42-2.28-7.1-5.9-7.16c-3.64-0.06-6.06,2.62-6.08,6.96c-0.04,11.34-0.04,22.67,0,34.01c0.02,4.33,2.45,7.03,6.07,6.97
			c3.6-0.06,5.87-2.75,5.9-7.16C352.54,110.21,352.5,104.6,352.5,99z"
    ></path>

    <path
      d="M250.92,302.12c1.43-8.81,2.76-18.09,4.52-27.29c0.64-3.35-0.06-5.56-2.49-7.9c-6.02-5.82-11.75-11.94-17.63-17.9
			c-2.05-2.07-3.55-4.3-2.43-7.33c1.03-2.79,3.29-3.75,6.12-4.14c8.04-1.11,16.04-2.48,24.08-3.62c3-0.43,5.04-1.33,6.39-4.54
			c3.32-7.94,7.27-15.61,10.87-23.43c1.29-2.81,2.94-5.01,6.33-4.92c3.2,0.08,4.74,2.25,5.97,4.91c3.65,7.94,7.54,15.77,11.05,23.76
			c1.16,2.64,2.72,3.71,5.47,4.08c8.41,1.14,16.79,2.55,25.19,3.77c2.86,0.41,5.49,1.63,5.71,4.48c0.17,2.17-0.77,5-2.23,6.61
			c-5.69,6.31-11.68,12.36-17.78,18.27c-2.41,2.34-3.15,4.54-2.5,7.9c1.68,8.7,2.87,17.49,4.33,26.24c0.47,2.84,0.15,5.73-2.56,6.77
			c-2.01,0.77-5,0.71-6.92-0.25c-7.91-3.98-15.53-8.55-23.39-12.63c-1.34-0.7-3.67-0.69-5.01,0.01
			c-7.97,4.15-15.75,8.66-23.67,12.91C255.52,310.47,250.78,307.7,250.92,302.12z M264.74,291.77c5.84-3.22,11.1-5.83,16.04-8.94
			c3.99-2.51,7.45-2.51,11.43-0.03c5.01,3.12,10.3,5.77,15.99,8.91c-1.11-7.02-1.81-13.36-3.2-19.54c-0.97-4.35,0.2-7.37,3.32-10.33
			c4.58-4.33,8.84-8.99,13.69-13.99c-7.07-1.1-13.3-2.24-19.58-2.98c-3.81-0.45-6.05-2.31-7.55-5.74
			c-2.53-5.78-5.32-11.44-8.39-17.96c-2.74,5.8-5.42,10.7-7.38,15.87c-2.02,5.33-5.36,7.89-11.08,8.28
			c-5.48,0.38-10.91,1.59-16.36,2.44c-0.35,0.55-0.71,1.1-1.06,1.65c5.1,4.59,10.21,9.18,15.31,13.78c2.25,2.03,2.84,4.49,2.3,7.46
			C267.02,277.41,265.99,284.18,264.74,291.77z"
    ></path>
    <path
      d="M196.82,248.99c-3.87,0-7.75,0.07-11.62-0.02c-4.4-0.09-6.63-2.34-6.67-6.79c-0.07-7.5-0.08-15,0-22.49
			c0.05-4.41,2.31-6.63,6.78-6.67c7.5-0.07,15-0.08,22.49,0c4.41,0.05,6.64,2.32,6.68,6.78c0.07,7.5,0.08,15,0,22.49
			c-0.05,4.4-2.33,6.6-6.78,6.69C204.07,249.05,200.44,248.99,196.82,248.99z M202.43,225.24c-4.12,0-7.9,0-11.66,0
			c0,4.03,0,7.81,0,11.46c4.06,0,7.85,0,11.66,0C202.43,232.78,202.43,229.18,202.43,225.24z"
    ></path>
    <path
      d="M376.26,248.99c-3.75,0-7.5,0.08-11.25-0.02c-4.18-0.11-6.44-2.36-6.49-6.59c-0.08-7.62-0.09-15.25,0-22.87
			c0.05-4.19,2.34-6.44,6.58-6.49c7.62-0.08,15.25-0.09,22.87,0c4.18,0.05,6.45,2.35,6.49,6.58c0.08,7.62,0.09,15.25,0,22.87
			c-0.05,4.18-2.36,6.4-6.58,6.5C384.01,249.06,380.14,248.99,376.26,248.99z M370.77,225.16c0,4.1,0,7.88,0,11.54
			c4.06,0,7.85,0,11.53,0c0-4,0-7.69,0-11.54C378.4,225.16,374.71,225.16,370.77,225.16z"
    ></path>
    <path
      d="M136.64,273.01c3.75,0,7.5-0.07,11.25,0.02c4.22,0.1,6.53,2.31,6.58,6.5c0.09,7.62,0.09,15.25,0,22.87
			c-0.05,4.22-2.32,6.53-6.5,6.58c-7.62,0.09-15.25,0.09-22.87,0c-4.23-0.05-6.52-2.31-6.57-6.5c-0.09-7.62-0.09-15.25,0-22.87
			c0.05-4.23,2.3-6.47,6.49-6.58C128.89,272.93,132.77,273.01,136.64,273.01z M130.67,296.74c4.07,0,7.85,0,11.54,0
			c0-4.05,0-7.83,0-11.55c-3.99,0-7.68,0-11.54,0C130.67,289.07,130.67,292.77,130.67,296.74z"
    ></path>
    <path
      d="M196.5,308.99c-3.87,0-7.75,0.09-11.62-0.02c-3.99-0.12-6.29-2.36-6.34-6.34c-0.1-7.75-0.1-15.5,0-23.24
			c0.05-3.99,2.34-6.29,6.33-6.34c7.75-0.1,15.5-0.1,23.24,0c3.99,0.05,6.29,2.35,6.34,6.33c0.1,7.75,0.1,15.5,0,23.24
			c-0.05,3.98-2.36,6.24-6.34,6.35C204.25,309.08,200.37,308.99,196.5,308.99z M190.67,296.74c4.07,0,7.85,0,11.54,0
			c0-4.05,0-7.83,0-11.55c-3.99,0-7.68,0-11.54,0C190.67,289.07,190.67,292.77,190.67,296.74z"
    ></path>
    <path
      d="M376.51,273.01c3.87,0,7.75-0.09,11.62,0.02c3.98,0.11,6.28,2.36,6.33,6.35c0.1,7.75,0.1,15.5,0,23.24
			c-0.05,3.98-2.37,6.28-6.35,6.33c-7.75,0.1-15.5,0.1-23.24,0c-3.99-0.05-6.27-2.36-6.32-6.35c-0.1-7.75-0.1-15.5,0-23.24
			c0.05-3.99,2.35-6.22,6.35-6.33C368.76,272.93,372.63,273.01,376.51,273.01z M370.81,285.08c0,3.89,0,7.76,0,11.67
			c3.91,0,7.69,0,11.41,0c0-4.04,0-7.82,0-11.67C378.33,285.08,374.73,285.08,370.81,285.08z"
    ></path>
    <path
      d="M154.49,351.37c0,3.75,0.09,7.5-0.02,11.25c-0.12,3.98-2.37,6.29-6.35,6.34c-7.75,0.1-15.5,0.1-23.24,0
			c-3.99-0.05-6.28-2.35-6.33-6.34c-0.1-7.75-0.1-15.5,0-23.24c0.05-3.99,2.34-6.28,6.33-6.34c7.75-0.1,15.5-0.1,23.24,0
			c3.98,0.05,6.23,2.35,6.35,6.34C154.58,343.37,154.49,347.37,154.49,351.37z M142.28,356.82c0-3.97,0-7.75,0-11.57
			c-4,0-7.79,0-11.5,0c0,4.04,0,7.83,0,11.57C134.77,356.82,138.46,356.82,142.28,356.82z"
    ></path>
    <path
      d="M214.49,351.37c0,3.75,0.09,7.5-0.02,11.25c-0.12,3.98-2.37,6.29-6.35,6.34c-7.75,0.1-15.5,0.1-23.24,0
			c-3.99-0.05-6.28-2.35-6.33-6.34c-0.1-7.75-0.1-15.5,0-23.24c0.05-3.99,2.34-6.28,6.34-6.33c7.75-0.1,15.5-0.1,23.24,0
			c3.98,0.05,6.23,2.35,6.34,6.34C214.58,343.37,214.49,347.38,214.49,351.37z M190.77,345.16c0,4.1,0,7.88,0,11.54
			c4.06,0,7.85,0,11.53,0c0-4,0-7.69,0-11.54C198.4,345.16,194.71,345.16,190.77,345.16z"
    ></path>
    <path
      d="M274.49,351.24c0,3.62,0.05,7.25-0.01,10.87c-0.08,4.49-2.25,6.81-6.61,6.86c-7.62,0.09-15.25,0.09-22.87,0
			c-4.18-0.05-6.43-2.36-6.48-6.59c-0.08-7.62-0.09-15.25,0-22.87c0.05-4.19,2.35-6.43,6.58-6.48c7.62-0.08,15.25-0.09,22.87,0
			c4.18,0.05,6.39,2.35,6.49,6.58C274.56,343.49,274.49,347.36,274.49,351.24z M250.67,356.74c4.07,0,7.85,0,11.54,0
			c0-4.05,0-7.83,0-11.55c-3.99,0-7.68,0-11.54,0C250.67,349.07,250.67,352.77,250.67,356.74z"
    ></path>
    <path
      d="M316.76,369c-3.75,0-7.5,0.04-11.25-0.01c-4.71-0.07-6.95-2.23-7-6.85c-0.07-7.37-0.06-14.75,0-22.12
			c0.04-4.71,2.21-6.95,6.84-7c7.37-0.07,14.75-0.06,22.12,0c4.7,0.04,6.96,2.22,7,6.84c0.07,7.37,0.06,14.75,0,22.12
			c-0.04,4.84-2.27,6.96-7.22,7.01C323.76,369.03,320.26,369,316.76,369z M322.31,356.85c0-4.12,0-7.81,0-11.63
			c-3.97,0-7.75,0-11.56,0c0,4.01,0,7.79,0,11.63C314.7,356.85,318.39,356.85,322.31,356.85z"
    ></path>
    <path
      d="M394.49,351.2c0,3.75,0.08,7.5-0.02,11.25c-0.11,4.2-2.35,6.48-6.55,6.53c-7.62,0.09-15.25,0.09-22.87,0
			c-4.2-0.05-6.47-2.34-6.52-6.55c-0.09-7.62-0.09-15.25,0-22.87c0.05-4.21,2.32-6.47,6.54-6.52c7.62-0.09,15.25-0.09,22.87,0
			c4.2,0.05,6.43,2.33,6.53,6.54C394.57,343.45,394.49,347.32,394.49,351.2z M370.63,356.7c4.19,0,7.97,0,11.67,0
			c0-4,0-7.69,0-11.47c-3.98,0-7.76,0-11.67,0C370.63,349.16,370.63,352.85,370.63,356.7z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "arrow-left",
  props: {
    fill: {
      default: "#fff"
    },
    height: {
      default: "20px"
    },
    width: {
      default: "20px"
    }
  }
};
</script>

<style>
</style>
